import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { PromptsDTO } from "src/app/models/Prompts/promptsDTO";
import { ServiceModeDTO } from "src/app/models/service-modes/service-modesDTO";

export const getServiceMode = createAction(
  "[ServiceModes] Get a Service Mode by code Action",
  props<{ code: string }>()
);
export const loadServiceMode = createAction(
  "[ServiceModes] Load a Service Mode by code Action",
  props<{ serviceMode: any }>()
);
export const getServiceModes = createAction(
  "[ServiceModes] Get All Service Modes Action",
  props<{ options: any }>()
);
export const loadServiceModes = createAction(
  "[ServiceModes] Load All Service Modes Action",
  props<{ response: any[] }>()
);
export const getServiceModesExcel = createAction(
  "[ServiceModes] Get All Service Modes Excel Action",
  props<{ options: any }>()
);
export const loadServiceModesExcel = createAction(
  "[ServiceModes] Load All Service Modes Excel Action",
  props<{ response: any[] }>()
);
// Table Configuration Settings
export const getServiceModeTableConfig = createAction(
  "[ServiceModes] Get Service Modes Table Configuration Action",
  props<{ options: any }>()
);
export const loadServiceModeTableConfig = createAction(
  "[ServiceModes] Load Service Modes Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveServiceModeTableConfig = createAction(
  "[ServiceModes] Save Service Modes Table Configuration Action",
  props<{ config: any }>()
);
export const updateServiceMode = createAction(
  "[ServiceModes] Update Service mode Action",
  props<{ serviceMode: ServiceModeDTO }>()
);
export const createServiceMode = createAction(
  "[ServiceModes] Create Service Mode Action",
  props<{ serviceMode: ServiceModeDTO }>()
);
export const resetServiceMode = createAction(
  "[ServiceModes] Reset Service Mode Action"
);
export const resetServiceModeState = createAction(
  "[ServiceModes] Reset Service Modes State Action"
);
export const resetCreation = createAction(
  "[ServiceModes] Reset Service Mode Creation Action"
);
export const getLoadingState = createAction(
  "[ServiceModes] Get Service Mode Loading State Action"
);

export const setLoadingStartState = createAction(
  "[ServiceModes] Set Service Mode Loading Start State Action"
);
export const setLoadingEndState = createAction(
  "[ServiceModes] Set Service Mode Loading End State Action"
);
